module.exports = __webpack_public_path__ + "res/32-img_game_top_bg_r.72ff98db2f53fbb7a3a6ea0bd84fc0f2.png";